import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const SERVICES = [
  {
    id: "walking",
    to: "/dog-walking",
    img: "/images/marypawpins/trio-sunny-viaduct.webp",
    alt: "A group of dogs at Mary's Meadow with Culloden Viaduct behind",
    title: "Dog Walking",
    copy: "Regular group walks, solo options and carefully chosen outdoor experiences across Inverness. Mary's Meadow provides 4.6 acres of private countryside space for suitable dogs to enjoy off-lead exercise.",
    link: "Explore Dog Walking",
  },
  {
    id: "sitting",
    to: "/pet-sitting",
    img: "/images/marypawpins/sleeping-dog-pink-bed.webp",
    alt: "A dog fast asleep and settled at home",
    title: "Pet Sitting",
    copy: "Personal in-home care for dogs and other pets while their owners are away. Familiar surroundings, established routines and clear communication make it easier for animals to remain settled.",
    link: "Explore Pet Sitting",
  },
  {
    id: "visits",
    to: "/home-visits",
    img: "/images/marypawpins/springer-puppy-red-bandana.jpg",
    alt: "A springer spaniel puppy in a red bandana",
    title: "Home Visits",
    copy: "Feeding, companionship, play, toileting and routine care for cats, puppies, senior dogs and other small domestic animals in their own homes.",
    link: "Explore Home Visits",
  },
];

export const Services = () => (
  <section className="py-16 sm:py-24 bg-[#EFECE3]" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="max-w-2xl">
        <p className="eyebrow">What I do</p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#292A26] tracking-tight mt-4" data-testid="services-heading">
          Care for every kind of day.
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {SERVICES.map((s) => (
          <article
            key={s.id}
            data-testid={`service-card-${s.id}`}
            className="group bg-white rounded-3xl overflow-hidden border border-[#DDD7CB] hover:border-[#3F4A38]/40 transition-colors shadow-[0_4px_24px_rgba(41,42,38,0.04)]"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={s.img}
                alt={s.alt}
                className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
            <div className="p-7 lg:p-8">
              <h3 className="font-serif text-2xl font-medium text-[#292A26]">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#575953]">{s.copy}</p>
              <Link
                to={s.to}
                data-testid={`service-link-${s.id}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#3F4A38] group-hover:gap-3 transition-[gap]"
              >
                {s.link}
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
